import axios from 'axios';

export function apiErrorMessage(error: unknown, fallback: string): string {
  const data: unknown = axios.isAxiosError(error) ? error.response?.data : null;
  const message = data && typeof data === 'object' && 'message' in data ? data.message : null;
  return typeof message === 'string' ? message : fallback;
}
